<template>
  <form novalidate @submit="onFormSubmit">
    <FormInputText
      label="Email Address"
      class="mb-4"
      name="email"
      type="email"
    />
    <FormSubmitButton
      type="submit"
      :is-submitting="isSubmitting"
      class="w-full"
    >
      Send Receipt
    </FormSubmitButton>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { emailAddressSchema } from "@/validation/sharedStringFieldSchemas"

const props = defineProps<{
  objectId: string
  receiptType: "order" | "transaction"
}>()

const emit = defineEmits<{
  (eventName: "submit-success"): void
}>()

const formSchema = z.object({
  email: emailAddressSchema(
    "Please enter a valid email address"
  ),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: { email: "" },
})

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    props.receiptType === "order"
      ? await sendOrderReceipt(props.objectId, formValues)
      : await sendTransactionReceipt(
          props.objectId,
          formValues
        )
    toast.success(`Receipt sent to ${formValues.email}`)
    emit("submit-success")
  } catch {
    toast.error("Failed to send receipt")
  }
})
</script>
